import React from "react";
import BaseMemoryGame from "./BaseMemoryGame";

// Example of custom memory game items
// Each item needs:
// - id: unique identifier
// - title: text for the "word" card
// - image: content for the "image" card (can be emoji or image path)
// - isImagePath: set to true if 'image' is a URL/path to an image
const sampleCustomItems = [
  {
    id: 1,
    title: "Dog",
    image: "",
    isImagePath: false,
  },
  {
    id: 2,
    title: "Cat",
    image: "/assets/memory-images/cat.png",
    isImagePath: true,
  },
  // Add more items as needed
];

const MemoryGame = ({ customItems }) => {
  // Combine provided custom items or use our sample ones
  const memoryItems = customItems || sampleCustomItems;

  return (
    <BaseMemoryGame
      title="Memory Match"
      subtitle="Match the word with its image!"
      shareText="I just played Memory Match on Flying Comet Games!"
      shareUrl={window.location.href}
      successBackgroundColor="#3D59A3"
      shareButtonColor={["#3D59A3", "#555"]}
      iconPath="/images/games/memory-match-icon.png"
      bannerPath="/images/games/memory-match-banner.png"
      logoPath="/assets/customer-logos/afro-logo.png"
      publicationId="MemoryMatchGame"
      customItems={memoryItems}
    />
  );
};

export default MemoryGame;
